import { Injectable, OnDestroy } from '@angular/core';
import { User } from '@gms/user-api';
import { select, Store } from '@ngrx/store';
import { IAppState } from 'app/store/app/app.state';
import { selectUser } from 'app/store/auth/auth.selectors';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService implements OnDestroy {
  private _expanded = true;
  private _menuState = new BehaviorSubject<boolean>(true);

  private isAccessInfopostPage = new BehaviorSubject<boolean>(true);

  isAccessPage$ = this.isAccessInfopostPage.asObservable();

  private _user$ = this.store.pipe(select(selectUser));


  constructor(private store: Store<IAppState>) {}

  toggleMenuExpanded() {
    this._expanded = !this._expanded;
    this._menuState.next(this._expanded);
  }

  isMenuExpanded$(): Observable<boolean> {
    return this._menuState.asObservable();
  }

  getUser$(): Observable<User> {
    return this._user$;
  }

  isAccessPage(isSelected: boolean) {
    this.isAccessInfopostPage.next(isSelected);
  }

  ngOnDestroy(): void {
    this._menuState.complete();
    this.isAccessInfopostPage.complete();
  }
}